export const conciliacaoSteps = [
  {
    target: '.stepImportarArquivo',
    content: `Acione este comando para fazer a importação do extrato bancário e realizar a conciliação.`,
    disableBeacon: true,
  },
  {
    target: '.stepRegrasAutomaticas',
    content: `Acione este comando para cadastrar, editar e excluir as regras automáticas referentes à conciliação bancária. Criando as regras, o sistema consegue acelerar a sua conciliação bancária.`,
  },
  {
    target: '.stepCredito',
    content: `Neste gráfico você consegue visualizar os valores de crédito que estão no extrato, mas ainda não estão no sistema.
              <br/><br/>
              Será exibida a diferença entre a soma dos valores referentes à créditos encontrados no extrato e a soma de todas as contas a receber do sistema no mesmo período (que não tem correspondência no extrato).`,
    placement: 'right-end'
  },
  {
    target: '.stepDebito',
    content: `Neste gráfico você consegue visualizar os valores de débito que estão no extrato, mas ainda não estão no sistema.
              <br/><br/>
              Será exibida a diferença entre a soma dos valores referentes à débitos encontrados no extrato e a soma de todas as contas a pagar do sistema no mesmo período (que não tem correspondência no extrato).`,
    placement: 'right-end'
  },
  {
    target: '.stepSaldoFinal',
    content: `Neste gráfico você consegue visualizar a diferença entre os valores apresentados nos dashboards "Crédito" e "Débito".`,
    placement: 'left-end'
  },
  {
    target: '.stepConciliacoesPendentes',
    content: `Neste gráfico você consegue visualizar o somatório de registros do extrato que não foram conciliados com o sistema no período pesquisado e os lançamentos do sistema, no mesmo período, que não tem correspondência no extrato.`,
    placement: 'left-end'
  },
  {
    target: '.stepFiltros',
    content: `Utilize os filtros para exibição das conciliações bancárias desejadas.`,
  },
  {
    target: '.stepExtratoBancario',
    content: `Nesta coluna serão exibidas as movimentações da conta bancária informada no filtro.`,
  },
  {
    target: '.stepLancamentosSistema',
    content: `Nesta coluna serão exibidos os lançamentos feitos no sistema conforme filtros informados.`,
  },
];